import React, { lazy } from "react";
import AdminStats from "../../Components/Admin/Statistics/AdminStats";
const AdminLogin = lazy(() => import("../../Components/Admin/AdminLogin"));
const AdminConsole = lazy(() => import("../../Components/Admin/AdminConsole"));
const AdminBlog = lazy(() => import("../../Components/Admin/Blog/AdminBlog"));
const AddArticle = lazy(() => import("../../Components/Admin/Blog/AddArticle"));
const ListArticles = lazy(() => import("../../Components/Admin/Blog/ListArticles"));
const SupportTickets = lazy(() => import("../../Components/Admin/Contact/SupportTickets"));


const adminRoutes = [
    {
        index: true,
        element: <AdminConsole />,
    },
    {
        path: "blog",
        element: <AdminBlog />,
    },
    {
        path: "stats",
        element: <AdminStats />,
    },
    {
        path: "blog_add",
        element: <AddArticle />,
    },
    {
        path: "blog_list",
        element: <ListArticles />,
    },
    {
        path: "tickets_list",
        element: <SupportTickets />,
    },
    {
        path: "login",
        element: <AdminLogin />,
    },
];

export default adminRoutes.map(a => ({
    ...a, handle: { admin: true }
}));
